import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormInput from "../FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import swal from 'sweetalert2';
import Preloader from "../Preloader";
import '../../styles/common.css';
import { getDisplayDateTimeFormat } from "../../util/generalUtills";
import { addEnquiryNotes } from "../../redux/actions/EnquiryActions";
import Select from "react-dropdown-select";

const EnquiryNote = ({ show, onHide, enquiryid, enquiryNoteLists }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const dispositionOptions = [
        {
            id: "Open",
            name: "Open",
        },
        {
            id: "Closed",
            name: "Closed",
        }
    ];
    const {
        AuthReducer: { auth, errors },
        enquiryReducer: { loadingEnquiry, errorsEnquiry, changedEnquiryStatus }
    } = useSelector((state) => state);

    const [formData, setFormData] = useState({
        title: "",
        disposition: "",
        note: "",
    });


    const inputHandler = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const selectHandler2 = (selectedData, name) => {
        setFormData(prev => ({ ...prev, [name]: selectedData }));
    };

    const handleSubmit = (event) => {

        event.preventDefault();

        const formDataToSend = new FormData();

        Object.keys(formData).forEach(key => {
            if (formData[key]) {
                formDataToSend.append(key, formData[key]);
            }
        });
        formDataToSend.append('enquiry_id', enquiryid);
        dispatch(addEnquiryNotes(auth?.token, formDataToSend));
    };

    useEffect(() => {
        if (errors && errors?.status === 401) {
            dispatch(logout());
            toast.error(errors?.data?.message);
            onHide();
        }
    }, [errors, dispatch, onHide]);

    useEffect(() => {
        if (changedEnquiryStatus?.success) {
            swal.fire({
                show: true,
                title: "Well done!",
                text: changedEnquiryStatus?.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });
            onHide();
            setFormData({title: "", disposition: "", note: "" });
            dispatch({ type: 'RESET_DELETE_ENQUIRY_STATUS' });
        }
    }, [changedEnquiryStatus, dispatch, onHide]);

    return (
        <Modal show={show} onHide={onHide} size="lg" backdrop="static" className="scrollable-modal">
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("Add Note to Enquiry")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorsEnquiry?.data?.message && (
                    <div className="alert alert-danger">
                        {errorsEnquiry?.data?.message}
                    </div>
                )}
                <Row>
                    <Col lg={6}>
                        <FormInput
                            label={t("Title")}
                            type="text"
                            errors={errorsEnquiry?.data}
                            value={formData.title}
                            name="title"
                            onChange={inputHandler}
                            containerClass="mb-1"
                            required
                        />
                    </Col>

                    <Col lg={6}>
                        <Form.Label>{t(`Disposition`)}</Form.Label>
                        <Select
                            options={dispositionOptions}
                            values={dispositionOptions.filter(option => option?.id === formData?.disposition) || []}
                            name="disposition"
                            labelField="name"
                            valueField="id"
                            searchBy="name"
                            loading={false}
                            onChange={(selectedData) => {
                                if (selectedData && selectedData.length > 0) {
                                    const selectedDegreeId = selectedData[0]?.id;
                                    selectHandler2(selectedDegreeId, "disposition");
                                }
                            }}
                        />
                        {errorsEnquiry?.data?.disposition && (
                              <div className="invalid-feedback d-block">
                                <p className="text-danger">{errorsEnquiry?.data?.disposition}</p>
                              </div>
                            )}
                    </Col>

                    <Col lg={12}>
                        <FormInput
                            label={t("Description")}
                            type="textarea"
                            errors={errorsEnquiry?.data}
                            value={formData.note}
                            name="note"
                            onChange={inputHandler}
                            containerClass="mb-1"
                        />
                    </Col>
                </Row>
                <div className="d-flex justify-content-center">
                    {loadingEnquiry ? (
                        <Button color="primary" disabled>
                            <Spinner animation="border" size="sm" />
                            {t("Please wait ...")}
                        </Button>
                    ) : (
                        <Button type="button" onClick={handleSubmit} disabled={loadingEnquiry}>
                            {t("Add")}
                        </Button>
                    )}
                </div>

                <div className="notes-section mt-4">
                    <h5 className="notes-section-heading">{t("Notes")}</h5>
                    <div className="notes-list">
                        {enquiryNoteLists && enquiryNoteLists.length > 0 ? (
                            enquiryNoteLists.map(note => (
                                <div key={note.id} className="note-item mb-1 p-1">
                                    <div className="note-date text-end">{getDisplayDateTimeFormat(note.created_at)}</div>
                                    <div className="note-title d-flex justify-content-between">
                                        <strong>{note.title}</strong>
                                    </div>
                                    <div className="note-description">
                                        <p>{note.note}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center text-muted">{t("No notes added yet.")}</p>
                        )}
                    </div>
                </div>
            </Modal.Body>
            {loadingEnquiry && <Preloader />}
        </Modal>
    );
};

export default EnquiryNote;
